module.exports = new __parcel__URL__("quests_text.4b4a8d10.png").toString();